import tableCarrier from './carrier.config';
import tableShipper from './carrier.config';

export default function load(session) {
    return session?.client?.type === 'carrier' ? tableCarrier : tableShipper
};